import { Component, OnInit, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core'

import { ShareButton } from './shared/share-button.class'
import { ShareProvider } from './shared/share-provider.enum'

@Component({
  selector: 'cm-social-share',
  templateUrl: './social-share.component.html',
  styleUrls: ['./social-share.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SocialShareComponent implements OnInit {

  @Input() url: string

  @Input() facebook: any = '<i class="fa fa-facebook"></i>';
  @Input() twitter: any = '<i class="fa fa-twitter"></i>';
  @Input() google: any = '<i class="fa fa-google-plus"></i>';

  @Output() popUpClosed = new EventEmitter<ShareProvider>()

  buttons: ShareButton[] = []

  constructor() { }

  ngOnInit() {
    this.buttons.push(new ShareButton(
      ShareProvider.FACEBOOK,
      this.facebook,
      'facebook'
    ))

    this.buttons.push(new ShareButton(
      ShareProvider.TWITTER,
      this.twitter,
      'twitter'
    ))

    this.buttons.push(new ShareButton(
      ShareProvider.GOOGLEPLUS,
      this.google,
      'googleplus'
    ))
  }

  onShareClose(provider: ShareProvider) {
    console.log('closed !!!', provider)
    this.popUpClosed.emit(provider)
  }
}



// WEBPACK FOOTER //
// C:/Users/florian.gadal/Workspace/cinenow-web/src/app/social-share/social-share.component.ts